import {
  PHONE_LOOKUP_REQUEST,
  PHONE_LOOKUP_SUCCESS,
  PHONE_LOOKUP_FAIL,
  PHONE_LOOKUP_RESET,
  VIRTUAL_QR_PAYMENT_REQUEST,
  VIRTUAL_QR_PAYMENT_SUCCESS,
  VIRTUAL_QR_PAYMENT_FAIL,
  VIRTUAL_QR_PAYMENT_RESET,
  VIRTUAL_QR_VERIFY_REQUEST,
  VIRTUAL_QR_VERIFY_SUCCESS,
  VIRTUAL_QR_VERIFY_FAIL,
  VIRTUAL_QR_VERIFY_RESET,
} from "../constants/phoneLookupConstants.js";

// Phone lookup reducer
const phoneLookupReducer = (state = {}, action) => {
  switch (action.type) {
    case PHONE_LOOKUP_REQUEST:
      return { loading: true };
    case PHONE_LOOKUP_SUCCESS:
      return { loading: false, success: true, patients: action.payload };
    case PHONE_LOOKUP_FAIL:
      return { loading: false, error: action.payload };
    case PHONE_LOOKUP_RESET:
      return {};
    default:
      return state;
  }
};

// Virtual QR payment reducer
const virtualQrPaymentReducer = (state = {}, action) => {
  switch (action.type) {
    case VIRTUAL_QR_PAYMENT_REQUEST:
      return { loading: true };
    case VIRTUAL_QR_PAYMENT_SUCCESS:
      return { loading: false, success: true, paymentData: action.payload };
    case VIRTUAL_QR_PAYMENT_FAIL:
      return { loading: false, error: action.payload };
    case VIRTUAL_QR_PAYMENT_RESET:
      return {};
    default:
      return state;
  }
};

// Virtual QR payment verification reducer
const virtualQrVerifyReducer = (state = {}, action) => {
  switch (action.type) {
    case VIRTUAL_QR_VERIFY_REQUEST:
      return { loading: true };
    case VIRTUAL_QR_VERIFY_SUCCESS:
      return { loading: false, success: true, verificationData: action.payload };
    case VIRTUAL_QR_VERIFY_FAIL:
      return { loading: false, error: action.payload };
    case VIRTUAL_QR_VERIFY_RESET:
      return {};
    default:
      return state;
  }
};

export { phoneLookupReducer, virtualQrPaymentReducer, virtualQrVerifyReducer };